const TURNSTILE_SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAADpJR7JIopXGARQb'

let widgetId = null
let currentToken = null

/**
 * Renderiza o widget Turnstile de forma explícita em um container.
 * Usa appearance "interaction-only": invisível na maioria dos casos,
 * aparece somente se a interação manual for necessária.
 * @param {string} containerId - ID do elemento DOM onde o widget será renderizado
 */
export function renderTurnstileWidget(containerId) {
  if (typeof window === 'undefined' || !window.turnstile) return
  const container = document.getElementById(containerId)
  if (!container) return
  if (widgetId !== null) return

  widgetId = window.turnstile.render(`#${containerId}`, {
    sitekey: TURNSTILE_SITE_KEY,
    appearance: 'interaction-only',
    callback: (token) => {
      currentToken = token
    },
    'expired-callback': () => {
      currentToken = null
      widgetId = null
    },
    'error-callback': () => {
      currentToken = null
      console.warn('[Turnstile] Widget error — token não gerado')
    },
  })
}

/**
 * Retorna o token atual gerado pelo widget Turnstile.
 * @returns {string|null}
 */
export function getTurnstileToken() {
  return currentToken
}

/**
 * Reseta o widget Turnstile (útil após falha no pagamento para gerar novo token).
 */
export function resetTurnstileWidget() {
  if (widgetId !== null && window.turnstile) {
    window.turnstile.reset(widgetId)
    currentToken = null
  }
}
